import React from "react"
import SharpImage from "../utils/sharpImage"
import SupporterSummaryStyles from "./supporterSummary.styles"

export const SupporterSummary = ({ supporter }) => {
    const classes = SupporterSummaryStyles();

    const WrapLink = ({ children }) => {
        if (supporter.link)
            return (
                <a href={supporter.link} rel="noopener noreferrer" target="_blank" title={supporter.name}>
                    {children}
                </a>
            );
        return <>{children}</>
    }

    return (
        <div className={classes.supporterSummaryStyles}>
            <WrapLink href={supporter.link} rel="noopener">

                {supporter.image ?
                    <div className={classes.supporterSummaryImgContainerStyles}>
                        <SharpImage file={supporter.image} title={supporter.name} altText={supporter.name} className={classes.supporterSummaryImgStyles} />
                    </div>
                    : null}
            </WrapLink>
        </div>
    );
}

export default SupporterSummary
